<template>
  <div class="account">
    <section class="d-flex flex-column">
      <header class="masthead mb-auto">
        <HomeNav />
      </header>
    </section>
    <section v-if="!showPopup" class="col-md-8 container">
      <div class="form-upgrade card">
        <div class="plans-heading col-md-10">
          <h5 class="py-3 text-green">{{ getText("change_subscription_title_text") }}</h5>
        </div>
        <div class="tblrow py-2 col-md-10 bg-grey200">
          <div
            v-for="(plan, index) in subscriptions"
            :key="index"
            class="active-plan py-3"
          >
            <p>CURRENT PLAN: {{ plan.package }}</p>
            <strong> {{ plan.sub }} ₦{{ plan.price }}</strong>
            <p>Two screens</p>
          </div>
        </div>
        <div class="buttons1 py-3 col-md-10">
          <p>
            <strong>Select Package:</strong>
            <select
              class="form-control select-lg ml-3"
              id="exampleFormControlSelect1"
              v-model="currentPackage"
            >
              <option
                :value="item.id"
                v-for="(item, index) in packages"
                :key="index"
              >
                {{ item.title }}
              </option>
            </select>
          </p>
        </div>
        <div
          @click="onCardSelected(card, index)"
          v-for="(card, index) in currentSubsList"
          :key="index"
          class="tblrow1 row col-md-10"
        >
          <div class="column1 col-md-2 py-3 bg-grey200">
            <img
              v-if="card.package == 'selected'"
              class="check-icon col-md-4 col-center"
              src="../../assets/img/check_circle.svg"
              alt=""
            />
            <strong class="col-center col-md-12"> {{ card.title }}</strong>
          </div>
          <div class="column col-center1 py-3 col-md-8">{{ card.description }}</div>
          <div class="column py-3 col-md-2">
            <strong class="col-center">
              <small>{{ card.currency }}</small
              >{{ card.price }}
            </strong>
          </div>
        </div>
        <div class="tblrow2 col-md-10 py-3">
          <p>
            All plans offer unlimited TV shows and movies, on as many devices as
            you want. HD (720p), Full HD (1080p), Ultra HD (4K) and HDR
            availability subject to your Internet service and device
            capabilities. Not all content available in HD, Full HD, Ultra HD, or
            HDR.
          </p>
        </div>
        <div class="buttons2 col-md-10 py-3">
          <a
            v-bind:class="{ disabled: disableBtn, notdisabled: enableBtn }"
            @click="gotoPayment()"
            class="btn btn-primary btn-lg"
          >
            Continue
          </a>
          <a @click="goBack()" class="btn btn-light btn-lg ml-2">Go Back</a>
        </div>
      </div>
    </section>
    <section v-if="showPopup">
      <ConfirmSubscription
        :selectedCard="selectedCard"
        :currentPackage="currentPackage"
        :currentPlan="currentPlan"
        @clicked="onClickCancel"
      />
    </section>
  </div>
</template>


<script>
import ConfirmSubscription from "./ConfirmSubscription.vue";
import HomeNav from "@/components/HomeNav.vue";
export default {
  name: "ChangeSubscription",
  components: {
    ConfirmSubscription,
    HomeNav,
  },

  watch: {
    currentPackage: function (val) {
      var currentSubs = this.getSubsById(val);
      this.currentPackage = currentSubs.id;
      this.currentSubsList = currentSubs.subscriptions;
      this.selectedSubsPlan = this.selectedPlan;
      this.$store.dispatch("account").then((res) => {
        if (res) {
          this.subscriptions = res.response.subscriptions;
          this.getCurrentPlan();
        }
        this.$store.commit("setLoader", false);
      });
    },
  },
  methods: {
    getText(val) {
      		return this.$store.getters.getGlobalConfigs[val];
    	},
    getSubsById(pid) {
      this.cancelSelected();
      this.disableContinueBtn();
      this.getCurrentPlan();
      var currentPackageObj = this.packages.find((ele) => ele.id == pid);
      return currentPackageObj;
    },

    onCardSelected(card) {
      this.selectedCard = card;
      this.selectedPlan = this.selectedCard;
      this.updateList();
      this.enableContinueBtn();
    },

    gotoPayment() {
      this.showPopup = true;
    },
    
    getCurrentPlan() {
      for (let i = 0; i < this.currentSubsList.length; i++) {
        for (let j = 0; j < this.subscriptions.length; j++) {
          if (this.subscriptions[j].sub_id == this.currentSubsList[i].sub_id) {
            this.currentSubsList[i].package = "selected";
          } else this.currentSubsList[i].package = "notselected";
        }
      }
    },
    updateList() {
      for (let i = 0; i < this.currentSubsList.length; i++) {
        if (this.selectedCard.id == this.currentSubsList[i].id) {
          this.currentPlan = this.currentSubsList[i];
          this.currentSubsList[i].package = "selected";
        } else this.currentSubsList[i].package = "notselected";
      }
    },

    cancelSelected() {
      for (let i = 0; i < this.currentSubsList.length; i++) {
        if (this.selectedCard.id == this.currentSubsList[i].id) {
          this.currentSubsList[i].package = "notselected";
        } else this.currentSubsList[i].package = "notselected";
      }
    },

    disableContinueBtn() {
      this.enableBtn = false;
      this.disableBtn = true;
    },

    enableContinueBtn() {
      if (this.subscriptions[0].sub_id != this.selectedPlan.sub_id) {
        this.enableBtn = true;
        this.disableBtn = false;
      } else if (this.subscriptions[0].sub_id == this.selectedPlan.sub_id) {
        this.enableBtn = false;
        this.disableBtn = true;
      }
    },

    onClickCancel(value) {
      this.showPopup = false;
      this.disableContinueBtn();
      this.cancelSelected();
      this.getCurrentPlan();
    },

    goBack() {
      this.cancelSelected();
      this.$router.push("/account");
    },
  },

  created() {
    this.$store.commit("setLoader", true);
    this.packages = this.$store.state.packages;
    this.currentPackage = this.$store.state.packages[0].id;
  },

  data() {
    return {
      currentPlan: null,
      selectedCard: {},
      selectedSubsPlan: {},
      selectedPlan: {},
      subscriptions: [],
      packages: null,
      currentPackage: null,
      currentSubsList: [],
      showPopup: false,
      enableBtn: false,
      disableBtn: true,
    };
  },
};
</script>

<style scoped>
.active-plan {
  padding-left: 20px;
}
.active-plan > p {
  padding-top: 0px;
  padding-bottom: 5px;
  margin-top: 0px;
  margin-bottom: 0px;
}

.buttons1 {
  margin-top: 30px;
}

.buttons2 {
  display: flex !important;
  justify-content: center !important;
  color: #F1F2F2 !important
}

.card {
  border-radius: 20px;
}

.column1 {
  border-radius: 5px 0px 0px 5px;
  font-size: 14px;
  display: flex !important;
  justify-content: center !important;
}

.col-center {
  margin: auto;
  margin-left: 0px;
  padding-left: 0px;
} 
.col-center1 {
  margin: auto;
} 
.column {
  font-size: 17px;
  display: flex !important;
  justify-content: center !important;
}

.check-icon {
  position: relative;
  left: -3px;
  margin-right: 0px !important;
  padding-right: 0px !important;
  transform: translate(-50%, 2%); 
  height: 60px;
  width: 60px;
  display: flex !important;
  justify-content: center !important;
}

.container {
  align-items: center;
  padding-top: 5%;
  padding-bottom: 5%;
}

.form-upgrade {
  align-items: center !important;
}

header.masthead {
  background-color: #679f3d !important;
}

.plans-heading {
  text-align: center;
  padding-top: 30px;
}

.row {
  margin-top: 6px;
  margin-bottom: 6px;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
}

.select-lg:hover {
  cursor: pointer;
  border-color: #679f3d !important;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(176, 247, 89, 0.596) !important;
  box-shadow: 0 0 0 0.2rem rgba(162, 226, 85, 0.61) !important;
}

.tblrow2 {
  font-size: 10px;
}

.tblrow1 {
  cursor: pointer;
  border: 1px solid black;
  border-radius: 5px;
  color: black !important;
}

.tblrow1:hover {
  border-color: #679f3d !important;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(176, 247, 89, 0.596) !important;
  box-shadow: 0 0 0 0.2rem rgba(162, 226, 85, 0.61) !important;
}
</style>